import { createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from './store';
import { removeSelectedProduct } from './ProductSlice';

interface UIState {
    isProductFormOpen: boolean;
}

const initialState: UIState = { isProductFormOpen: false };

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        openProductForm(state) {
            state.isProductFormOpen = true;
        },
        closeProductForm(state) {
            state.isProductFormOpen = false;
        },
    },
});

export const { openProductForm, closeProductForm } = uiSlice.actions;
export default uiSlice.reducer;

export const closeProductFormSafely = () => (dispatch: AppDispatch) => {
    dispatch(closeProductForm());
    dispatch(removeSelectedProduct());
};
